




























































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import VWidget from '@/components/VWidget.vue';
import VDraggableTreeview from '@/components/controls/treeview/DraggableTreeview.vue';

@Component({
    components: { VWidget, VDraggableTreeview }
})
export default class Categories extends AbpBase {
    entity: string = 'category';
    selected: any = null;
    folderName: string = '';
    openAll: boolean = false;
    showOrder: boolean = false;
    hasChanges: boolean = false;
    items: Array<any> = [];

    get loading() {
        return this.$store.state.category.loading;
    }

    get loadingPos() {
        return this.$store.state.category.loadingPos;
    }        

    get list() {
        return this.$store.state.category.list;            
    }

    changeFolder(item) {
        this.selected = item[0];

        let vm = this;
        setTimeout(() => {                
            (vm.$refs.textFolder as any).focus();
        }, 100);
    }

    async updateItems(value) {
        if (value != undefined)
            this.items = value;
        this.hasChanges = true;
    }

    async save() {
        await this.$store.dispatch({
            type: 'category/create',
            data: {
                parent_id: this.selected,
                name: this.folderName
            }
        });
        this.folderName = '';
        await this.getpage();
    }

    async savePositions() {
        await this.$store.dispatch({
            type: 'category/savePositions',
            data: this.items
        });

        this.items = this.$store.state.category.list;
        this.hasChanges = false;
    }

    async updateCategory(item) {
        await this.$store.dispatch({
            type: 'category/update',
            data: {
                id: item.id,
                name: item.name
            }
        });
        await this.getpage();
    }

    async deleteCategory(item) {
        this.$swal({
            title: '&iquest;Est&aacute; seguro?',
            html: 'Al eliminar esta carpeta se eliminaran todas las carpetas inferiores, OJO: Solo se puede eliminar si no existen documentos',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, &iexcl;Eliminar!',
            cancelButtonText: '&iexcl;No!',
            cancelButtonColor: '#FF5252',
            showCloseButton: true,
            showLoaderOnConfirm: true
        }).then(async (result) => {
            if (result.value) {
                await this.$store.dispatch({
                    type: 'category/delete',
                    data: item
                });
                await this.getpage();

                this.$swal('Eliminado', 'El folder ha sido eliminado', 'success')
            }
        });           
    }        

    async getpage() {
        await this.$store.dispatch({
            type: 'category/getAll'
        });

        this.items = this.$store.state.category.list;
    }

    async mounted() {
        this.hasChanges = false;
        await this.getpage();
    }

    created() {

    }
}